<div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="myExtraLargeModalLabel">
        <ng-container>
          View Api Key
        </ng-container>
      </h4>
      <button type="button" class="close" (click)="close()">×</button>
    </div>
    <div class="modal-body">
      <div class="card-box">
        <form class="form-horizontal" role="form" autocomplete="off">
          <div class="form-group row">
            <label for="service" class="col-4 col-form-label">API Key</label>
            <div class="col-8">
              <textarea id="apikey" class="col-12 form-control" name="apikey" rows="4" cols="50">{{apikey}}</textarea>
            </div>
          </div>

          <div class="form-group row float-right">
            <div class="col-12">
              <button type="button" class="btn btn-info waves-effect waves-light" (click)="close()"><i class="mdi  mr-1"></i>Close</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
